import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { HideToast, ShowToast } from '@/store/toast/actions';

export const useShowTemplateIsBeingSavedToast = (): { showTemplateIsBeingSavedToast: () => void } => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const showTemplateIsBeingSavedToast = (): void => {
        dispatch(
            ShowToast({
                message: t('templateisbeingsaved'),
                severity: 'info',
                duration: 6000,
                width: 380,
                onClose: HideToast,
            })
        );
    };
    return { showTemplateIsBeingSavedToast };
};
